import moment from "moment";

import { DriverFormValues } from "../components";
import { DriverCertificateType } from "../constants";
import { DriverDetailsData } from "../drivers.types";

export const getEditableDriverFormValues = (
  driver: DriverDetailsData
): DriverFormValues => {
  return {
    id: driver?.id,
    phoneNumber: driver.phoneNumber,
    firstname: driver.firstname,
    lastname: driver.lastname,
    address: driver.address,
    birthdate: moment(driver.birthdate).toDate(),
    image: driver.image,
    password: "",
    repeatPassword: "",
    priority: driver.priority,
    capacity: driver.capacity,
    deliveryZones: driver.deliveryZones.map((deliveryZone) => ({
      id: deliveryZone.id,
      value: deliveryZone.id
    })),
    driverLicense: {
      type: DriverCertificateType.DriverLicense,
      reference: driver.driverLicense.reference ?? "",
      images: driver.driverLicense.images ?? []
    },
    insurance: {
      type: DriverCertificateType.Insurance,
      reference: driver.insurance.reference ?? "",
      images: driver.insurance.images ?? []
    },
    idLicense: {
      type: DriverCertificateType.Id,
      reference: driver.idLicense.reference ?? "",
      images: driver.idLicense.images ?? []
    },
    vehicle: {
      type: DriverCertificateType.Vehicle,
      reference: driver.vehicle.reference ?? "",
      images: driver.vehicle.images ?? []
    },
    totalCargoVolume: driver.totalCargoVolume,
    totalCargoWeight: driver.totalCargoWeight,
    isActive: driver.isActive,
    deliveryCompanyId: driver.deliveryCompanyId ?? null
  };
};
